import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

const WhatsAppPhoneOutlined = forwardRef<SVGSVGElement, BusinessIconImageProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-0.18685 -0.186419) scale(0.870489)">
        <path d="M22.0466 5.85036C19.8978 3.6964 17.0361 2.51172 13.9949 2.51172C7.71761 2.51172 2.60965 7.61968 2.60965 13.8969C2.60965 15.9022 3.13275 17.8613 4.12768 19.5896L2.51221 25.4873L8.54843 23.9026C10.2101 24.8103 12.0819 25.2873 13.9897 25.2873H13.9949C20.267 25.2873 25.4878 20.1793 25.4878 13.9021C25.4878 10.8609 24.1954 8.00432 22.0466 5.85036ZM13.9949 23.3692C12.2922 23.3692 10.6255 22.9128 9.1741 22.0512L8.83049 21.8461L5.25081 22.7846L6.20471 19.2921L5.97906 18.9331C5.03029 17.4253 4.53283 15.6868 4.53283 13.8969C4.53283 8.68128 8.77921 4.4349 14 4.4349C16.5283 4.4349 18.9028 5.41957 20.6875 7.20941C22.4722 8.99924 23.5697 11.3737 23.5646 13.9021C23.5646 19.1229 19.2105 23.3692 13.9949 23.3692ZM19.1849 16.2817C18.9028 16.1381 17.5028 15.4509 17.2412 15.3586C16.9796 15.2611 16.7899 15.215 16.6001 15.5022C16.4104 15.7894 15.8668 16.4253 15.6975 16.6202C15.5334 16.8099 15.3642 16.8356 15.0821 16.692C13.4102 15.856 12.3127 15.1996 11.2101 13.3072C10.9178 12.8046 11.5024 12.8405 12.046 11.7532C12.1384 11.5635 12.0922 11.3994 12.0204 11.2558C11.9486 11.1122 11.3793 9.7121 11.1434 9.14284C10.9127 8.58897 10.6767 8.66589 10.5024 8.65564C10.3383 8.64538 10.1485 8.64538 9.95876 8.64538C9.769 8.64538 9.4613 8.71718 9.19974 8.99924C8.93819 9.28644 8.20482 9.97366 8.20482 11.3737C8.20482 12.7738 9.22539 14.1277 9.36386 14.3175C9.50745 14.5072 11.3691 17.3792 14.2257 18.6151C16.0309 19.3947 16.7386 19.4613 17.6412 19.328C18.19 19.2459 19.3234 18.6408 19.5593 17.9741C19.7952 17.3074 19.7952 16.7381 19.7234 16.6202C19.6567 16.492 19.467 16.4202 19.1849 16.2817Z" />
      </g>
    </svg>
  ),
);

WhatsAppPhoneOutlined.displayName = 'WhatsAppPhoneOutlined';

export default WhatsAppPhoneOutlined;
